import { Button, Checkbox, Col, Form, Input, Row, Select } from 'antd';
import { ConfigProvider, CountryPhoneInput } from 'antd-country-phone-input';
import en from 'world_countries_lists/data/en/world.json';

import { DemoSettings, DemoSettingsField, ECommerceSettings } from 'Types';

import './styles.scss';

const SettingsFromItem = (field: DemoSettingsField) => {
  if (!field.component) {
    return null;
  }

  const isHidden = field.component === 'hidden';
  const className = isHidden ? '' : 'table-row';

  return (
    <Form.Item
      key={field.name}
      className={className}
      valuePropName={field.component === 'checkbox' ? 'checked' : 'value'}
      initialValue={field.component === 'select' ? field.value?.id : field.value}
      name={field.name}
      label={field.label}
      hidden={isHidden}
    >
      {getInputByField(field)}
    </Form.Item>
  );
};

function getInputByField(field: DemoSettingsField) {
  if (field.component === 'hidden') {
    return null;
  }

  if (field.component === 'input') {
    return <Input />;
  }

  if (field.component === 'phone') {
    return <CountryPhoneInput />;
  }

  if (field.component === 'select') {
    if (!field.options) {
      console.warn('options array is required for select component');
      return null;
    }

    return (
      <Select>
        {field.options.map((option) => (
          <Select.Option key={option.id} value={option.id}>
            {option[field.optionLabel as string]}
          </Select.Option>
        ))}
      </Select>
    );
  }

  if (field.component === 'checkbox') {
    return <Checkbox />;
  }

  return null;
}

interface Props {
  onSubmit: (settings: ECommerceSettings) => void;
  settings: DemoSettings;
}

export function DemoSettingsForm({ settings, onSubmit }: Props) {
  return (
    <ConfigProvider locale={en}>
      <Form className="demo-settings-form" autoComplete="off" onFinish={onSubmit}>
        <table>{settings.fields.map(SettingsFromItem)}</table>
        <Form.Item>
          <Row justify="end">
            <Col>
              <Button type="primary" htmlType="submit">
                Play
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </ConfigProvider>
  );
}
